export const baseStationKey = 'base_station_sync_column';
export const noteKey = 'note_column';
export const graphKey = 'graph_column';
export const downloadlogKey = 'download_log_column';
export const stationKey = 'station_key_column';
